import { connect, Dispatch } from 'react-redux';
// import { actions } from 'react-redux-form';
import {
  getPropertyManager,
  createPropertyManager,
  editPropertyManager,
  lookupOffice /*, getPropertyManagementOfficeFromLoadedPropertyManager */
} from '../../property-manager.actions';
import {
  PropertyManagerComponent,
  PropertyManagerComponentProperties /*, loadedPropertyManagementOffice */
} from './property-manager.component';
import { AppState } from '../../..';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(
  state: AppState,
  ownProps: { isViewOnly: boolean; saveCallback: Function }
): Partial<PropertyManagerComponentProperties> {
  return {
    errorMessage: state.propertyManager.errorMessage,
    id: state.propertyManager.id,
    loadedPropertyManager: state.propertyManager.loadedComponentPropertyManager,
    saving: state.propertyManager.saving
    // loadedPropertyManagementOffice: state.propertyManager.loadedPropertyManagementOffice
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<AppState>,
  ownProps: { isViewOnly: boolean; saveCallback: Function }
): Partial<PropertyManagerComponentProperties> {
  return {
    submit: (formData, isModal) => {
      var val = parseInt('' + formData.id, 10);
      if ((formData.id && formData.id !== null && val > 0) || (val === 0 && '' + formData.id === '0')) {
        return dispatch(editPropertyManager(formData, ownProps.saveCallback, isModal));
      }
      formData = {
        ...formData,
        id: 0
      };
      return dispatch(createPropertyManager(formData, ownProps.saveCallback, isModal));
    },
    getPropertyManagerInfo: (id?: number) => {
      dispatch(getPropertyManager(id));
    },
    officeLookup(value: string, id: number) {
      return lookupOffice(value, id);
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const PropertyManager = connect(
  mapStateToProps,
  mapDispatchToProps
)(PropertyManagerComponent);



// WEBPACK FOOTER //
// ./src/property-manager/_components/property-manager/property-manager.container.ts